function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "32px",
    height: "32px",
    viewBox: "0 0 24 24",
    id: "caution-sign-circle",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke",
    x1: 11.95,
    y1: 16.5,
    x2: 12.05,
    y2: 16.5,
    style: {
      fill: "none",
      stroke: "#3d6472",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M3,12a9,9,0,0,1,9-9h0a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9h0a9,9,0,0,1-9-9Zm9,0V7",
    style: {
      fill: "none",
      stroke: "#3d6472",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.60b01f4f3c72a1d454b1d5f0a6d81d81.svg";
export { ForwardRef as ReactComponent };